import {
    tss,
} from 'app/tss'

const general = 'general'
const regionalService = 'regionalService'

export default tss.create(({
    theme,
}) => {
    return {
        warningText: {
            fontWeight: theme.typography.h4.fontWeight,
            paddingRight: theme.spacing(1),
        },
        gridWrapper: {
            display: 'grid',
            gap: theme.spacing(2),
            gridTemplateAreas: `
                "${general} ${general} ${regionalService} ${regionalService}"
            `,
            gridTemplateColumns: 'repeat(4, 1fr)',
        },
        general: {
            gridArea: general,
        },
        regionalService: {
            gridArea: regionalService,
        },
        green: {
            '&&': {
                color: `${theme.palette.common.green} !important`,
            },
        },
        red: {
            '&&': {
                color: `${theme.palette.common.red} !important`,
            },
        },
    }
})
